import { def } from './def'
import { pdc } from './pdc'

/*
fields: {type, x, y, w, h, default, fontSize, readonly, align}

- t   : textfield              -> value: string
- ta  : textarea               -> value: string
- y  : yes / n/a               -> value: 'yes' | 'na'
- yn : yes / no / n/a          -> value: 'yes' | 'no' | 'na'
- c : yes                      -> value: 'yes'
- i   : image (upload/preview) -> value: { file: File, url: string }
*/

export const docs = (props) => {
    const now_date = `${new Date().getFullYear()} / ${String(new Date().getMonth() + 1).padStart(2, '0')} / ${String(new Date().getDate()).padStart(2, '0')}`
    const now_time = (() => {
        const now = new Date()
        const hours = now.getHours()
        const minutes = String(now.getMinutes()).padStart(2, '0')
        const period = hours >= 12 ? 'م' : 'ص'
        const hour12 = hours % 12 || 12

        return `${String(hour12).padStart(2, '0')}:${minutes} ${period}`
    })()
    const functional_location = `4100-${(props.site_type || '').toUpperCase()}-${String(props.feeder).padStart(6, '0')}`

    const context = {
        ...props,
        now_date,
        now_time,
        functional_location
    }

    return {
        def: def(context),
        pdc: pdc(context)
    }
}